var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#D7C0FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12C18 15.3137 15.3137 18 12 18C8.68628 18 6 15.3137 6 12C6 8.68629 8.68628 6 12 6C15.3137 6 18 8.68629 18 12Z",
    fill: "#6000E9",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.5C12 5.5 13.3221 5.5 14.5302 6.01101C14.5302 6.01101 15.6968 6.50442 16.5962 7.40381C16.5962 7.40381 17.4956 8.30319 17.989 9.46975C17.989 9.46975 18.5 10.6779 18.5 12C18.5 12 18.5 13.3221 17.989 14.5302C17.989 14.5302 17.4956 15.6968 16.5962 16.5962C16.5962 16.5962 15.6968 17.4956 14.5302 17.989C14.5302 17.989 13.3221 18.5 12 18.5C12 18.5 10.6779 18.5 9.46975 17.989C9.46975 17.989 8.30319 17.4956 7.40381 16.5962C7.40381 16.5962 6.50442 15.6968 6.01101 14.5302C6.01101 14.5302 5.5 13.3221 5.5 12C5.5 12 5.5 10.6779 6.01101 9.46975C6.01101 9.46975 6.50442 8.30319 7.40381 7.40381C7.40381 7.40381 8.30319 6.50442 9.46975 6.01101C9.46975 6.01101 10.6779 5.5 12 5.5ZM12 6.5C12 6.5 10.8807 6.5 9.85931 6.93201C9.85931 6.93201 8.87238 7.34945 8.11091 8.11091C8.11091 8.11091 7.34945 8.87238 6.93201 9.85931C6.93201 9.85931 6.5 10.8807 6.5 12C6.5 12 6.5 13.1193 6.93201 14.1407C6.93201 14.1407 7.34945 15.1276 8.11091 15.8891C8.11091 15.8891 8.87238 16.6506 9.85931 17.068C9.85931 17.068 10.8807 17.5 12 17.5C12 17.5 13.1193 17.5 14.1407 17.068C14.1407 17.068 15.1276 16.6506 15.8891 15.8891C15.8891 15.8891 16.6506 15.1276 17.068 14.1407C17.068 14.1407 17.5 13.1193 17.5 12C17.5 12 17.5 10.8807 17.068 9.85931C17.068 9.85931 16.6506 8.87238 15.8891 8.11091C15.8891 8.11091 15.1276 7.34945 14.1407 6.93201C14.1407 6.93201 13.1193 6.5 12 6.5Z",
    fill: "#6000E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5H12.5C12.7761 15.5 13 15.2761 13 15C13 14.7239 12.7761 14.5 12.5 14.5V11.5C12.5 11.2239 12.2761 11 12 11H11.5C11.2239 11 11 11.2239 11 11.5C11 11.7761 11.2239 12 11.5 12V15C11.5 15.2761 11.7239 15.5 12 15.5Z",
    fill: "#6000E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 9.25C12.625 9.66422 12.2892 10 11.875 10C11.4608 10 11.125 9.66422 11.125 9.25C11.125 8.83578 11.4608 8.5 11.875 8.5C12.2892 8.5 12.625 8.83578 12.625 9.25Z",
    fill: "#6000E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.d135248b46e73919147ae218d4afff11.svg";
export { ForwardRef as ReactComponent };